export default __webpack_public_path__ + "static/media/kitchen3-before1-2048w.52972a39.avif";